import("./style.scss");

import DefaultLayout from "./default-layout";

import withRedux from "./with-redux";

export default withRedux(DefaultLayout);
